<template>
	<div class="receive-coins-toast">
		<CrystalAmount :amount="props.amount" class="reward" />
		{{ props.message }}
	</div>
</template>

<script setup lang="ts">
import CrystalAmount from './CrystalAmount.vue';

const props = defineProps<{
	message?: string;
	amount: number;
}>();
</script>

<style scoped>
.receive-coins-toast {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0px;
	gap: 4px;
}

.reward {
	font-family: 'Exo 2' !important;
	font-style: normal !important;
	font-weight: 600 !important;
	font-size: 13px !important;
	line-height: 16px !important;

	color: #ffffff !important;
}
</style>
